export const SEARCH = "SEARCH";
export const FILTER_DATA = "FILTER_DATA";
export const ACTIVE_FILTER = "ACTIVE_FILTER";
export const SECTION_DATA = "SECTION_DATA";
export const MENU_FIXED = "MENU_FIXED";
export const MENU_DATA = "MENU_DATA";
